(() => {
  'use strict';
  if (window.slMobileFirst) return;
  window.slMobileFirst = true;
  const mobile = matchMedia('(max-width:749px)');
  const copy = JSON.parse(document.querySelector('[data-sl-mobile-copy]')?.textContent || '{}');
  const wrappers = [];
  function prepareAddons() {
    const beam = document.querySelector('.sl-beam-buy-marker');
    const signal = document.querySelector('.sl-sg-buy');
    const addon = beam ? document.querySelector('.product-details .upsell-products-block') : signal?.querySelector('[data-sl-addons]');
    const action = beam ? document.querySelector('.product-details .buy-buttons-block') : signal?.querySelector('.sl-sg-form-row');
    if (!addon || !action || addon.dataset.mobilePrepared) return;
    addon.dataset.mobilePrepared = 'true';
    const marker = document.createComment('original accessory position');
    addon.before(marker);
    const details = document.createElement('details'); details.className = 'sl-mobile-addons'; details.open = true;
    const summary = document.createElement('summary'); summary.textContent = copy.optional || '';
    const count = document.createElement('span'); count.className = 'sl-mobile-addons-count'; summary.append(count);
    details.append(summary); addon.before(details); details.append(addon);
    const updateCount = () => { const selected = addon.querySelectorAll('input[type=checkbox]:checked').length; count.textContent = selected ? `${selected} ${copy.selected || ''}` : ''; };
    addon.addEventListener('change', updateCount);
    wrappers.push({ details, marker, action, wasMobile: null }); updateCount();
  }
  function arrange() {
    prepareAddons();
    for (const item of wrappers) {
      if (item.wasMobile === mobile.matches) continue;
      item.wasMobile = mobile.matches;
      if (mobile.matches) { item.action.before(item.details); item.details.open = !!item.details.querySelector('input:checked'); }
      else { item.marker.after(item.details); item.details.open = true; }
    }
    updatePurchase();
  }
  document.addEventListener('click', event => {
    const target = event.target;
    for (const menu of document.querySelectorAll('.sl-mobile-explore[open]')) {
      if (!menu.contains(target) || target.closest('a')) menu.open = false;
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') for (const menu of document.querySelectorAll('.sl-mobile-explore[open]')) menu.open = false; });
  const bar = document.querySelector('[data-sl-mobile-purchase]'), buy = bar?.querySelector('[data-sl-mobile-buy]');
  let raf = 0;
  const findSource = () => document.querySelector('.sl-sg-buy form button[type=submit],.product-details form[action*="/cart/add"] button[type=submit]');
  function updatePurchase() {
    raf = 0; if (!bar || !buy) return;
    const source = findSource(); if (!source) { bar.hidden = true; return; }
    const rect = source.getBoundingClientRect(), top = document.querySelector('#header-component')?.getBoundingClientRect().bottom || 0;
    const preview = document.querySelector('#PBarNextFrameWrapper') || document.querySelector('#PBarNextFrame');
    const height = preview?.getBoundingClientRect().height || 0;
    const previewOffset = height > 0 && height < 150 ? height : 0;
    const visible = rect.bottom > Math.max(0, top) && rect.top < innerHeight - previewOffset - 12;
    bar.hidden = !mobile.matches || visible;
    buy.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
    if (!buy.dataset.idleLabel) buy.dataset.idleLabel = buy.textContent;
    const state = source.closest('form')?.dataset.slCartState;
    buy.textContent = state === 'busy' ? copy.adding : state === 'uncertain' ? copy.viewCart : state === 'error' ? copy.retry : buy.dataset.idleLabel;
    const feedback = bar.querySelector('[data-sl-mobile-feedback]');
    if (feedback) {
      feedback.hidden = state !== 'error' && state !== 'uncertain';
      feedback.textContent = state === 'uncertain' ? copy.connectionError : state === 'error' ? copy.cartError : '';
    }
    const price = document.querySelector('.sl-sg-price,.sl-beam-buy-summary .price');
    if (price) bar.querySelector('[data-sl-mobile-price]').textContent = price.textContent.trim();
    bar.style.setProperty('--sl-preview-offset', `${previewOffset}px`);
  }
  const schedule = () => { if (!raf) raf = requestAnimationFrame(updatePurchase); };
  buy?.addEventListener('click', () => {
    const source = findSource();
    if (!source || source.disabled) return;
    if (source.closest('form')?.dataset.slCartState === 'uncertain') {
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart'); return;
    }
    source.click(); schedule();
  });
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule, { passive: true });
  document.addEventListener('sl:cart-feedback', schedule);
  document.addEventListener('change', schedule); document.addEventListener('cart:update', schedule);
  if (bar) {
    const previewResize = new ResizeObserver(schedule);
    let observedPreview = null;
    const watchPreview = () => {
      const preview = document.querySelector('#PBarNextFrameWrapper');
      if (preview && preview !== observedPreview) { previewResize.disconnect(); previewResize.observe(preview); observedPreview = preview; schedule(); }
    };
    new MutationObserver(watchPreview).observe(document.body, { childList: true });
    watchPreview();
    const main = document.querySelector('#MainContent');
    new MutationObserver(schedule).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  }
  mobile.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
  arrange();
})();

